export default class AccessManagementAPIService {
  constructor($http, appSettings) {
    'ngInject';
    this.$http = $http;
    this.appSettings = appSettings;
    this.assignmentEndpointUrl = `${this.appSettings.InReachApiEndpoint}access/assignments`;
    this.accessEndpointUrl = `${this.appSettings.InReachApiEndpoint}access`;
  }
  performAssignments(assetIds, operatorsIds, command) {
    const assignments = {
      equipmentIds: assetIds,
      operatorIds: operatorsIds,
      command: command,
    };
    return this.$http.patch(this.assignmentEndpointUrl, assignments);
  }
  getOperatorsByAsset(assetId) {
    const url = `${this.assignmentEndpointUrl}/by/equipment/${assetId}`;
    return this.$http.get(url);
  }
  getAssetsByOperator(operatorId) {
    const url = `${this.assignmentEndpointUrl}/by/operator/${operatorId}`;
    return this.$http.get(url);
  }
  getAssetsBySearchFilter(filter) {
    const url = `${this.accessEndpointUrl}/search/filter`;
    return this.$http.post(url, filter);
  }
  getAssetById(assetId) {
    const url = `${this.accessEndpointUrl}/equipment/${assetId}`;
    return this.$http.get(url);
  }
  getAssetListByIds(assetIds) {
    const url = `${this.accessEndpointUrl}/search/equipmentlist`;
    return this.$http.post(url, assetIds);
  }
  enableAssets(assetIds = []) {
    const url = `${this.accessEndpointUrl}/enable`;
    return this.$http.post(url, { ids: assetIds });
  }
  getAssetsByGroupId(id) {
    const url = `${this.accessEndpointUrl}/equipment/group/${id}`;
    return this.$http.get(url);
  }
}
